import MARKDOWN from "@/legal/engineering-services-terms.md?raw";
import LegalShell from "./_LegalShell";
import LegalMarkdown from "./_LegalMarkdown";
import { LEGAL_UPDATED } from "@/legal/version";

export default function EngineeringTerms() {
  return (
    <LegalShell
      title="Engineering Services Terms"
      updated={LEGAL_UPDATED}
      description="Engineering Services Terms for ElectricSheepHQ Velocity retainers from 100Yen Inc.: how Retainer Agreements, scoping, ownership, fees, and cancellation work."
      canonicalPath="/engineering-terms"
    >
      <LegalMarkdown markdown={MARKDOWN} />
    </LegalShell>
  );
}
